import {createNetworkMiddleware} from 'react-native-offline';

export default createNetworkMiddleware();
